module.exports = __webpack_public_path__ + "static/img/login_icon.550353cc.png";